<template>
    <div style="position: relative">
        <title-and-edit currentViewTitle="Bestillinger" :layout="layout"/>
        <div class="profile__container--content__orderhistory primary-font pt-5">
            <div v-if="combinedOrders.length || (!combinedOrders.length && (currentSalon !== 'Alle salonger' || !currentTypes.includes('Alle typer')))">
                <div class="d-flex dropdown-container">
                    <profile-dropdown
                        class="dropdown-item mr-4"
                        v-if="layout == 'portal'"
                        defaultValue="Alle salonger"
                        fullwidth
                        :items="salons"
                        @select-item="updateOrderList"
                        :layout="layout"
                    ></profile-dropdown>

                    <profile-dropdown-multiselect
                        class="dropdown-item"
                        :defaultValue="['Kommende', 'Fullførte', 'Ikke møtt']"
                        multiple
                        fullwidth
                        :items="types"
                        @select-item="updateOrderListbyType"
                    ></profile-dropdown-multiselect>
                    </div>
                <!-- No results based on filter -->
                <div v-if="!loading && (!combinedOrders.length && (currentSalon !== 'Alle salonger' || !currentTypes.includes('Alle typer')))">
                    <p>Finner ingen historikk med dette filteret</p>
                </div>
                <!-- Orders -->
                <div v-for="order in visiblePages" :key="order.appointmentId">
                    <order @showOrderDetails="order => switchComponent(order)" :order="order" :layout="layout" :description="description(order)"></order>
                </div>
                <v-pagination
                    v-if="combinedOrders.length > 10"
                    class="profile__container--content__orderhistory--pagination my-5"
                    circle
                    v-model="page"
                    :length="pages"
                    :total-visible="10"
                    prev-icon="fxt-chevron-left"
                    next-icon="fxt-chevron-right">
                </v-pagination>
            </div>
            <div v-else>
                <v-overlay :value="loading" color="white" absolute style="height: 600px">
                    <v-progress-circular
                        color="var(--v-primary-base)"
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>
                <no-content v-if="!loading && (!combinedOrders.length && currentSalon === 'Alle salonger' && !currentTypes.includes('Alle typer'))" title="Du har ikke bestilt noe ennå." icon="fxt-calendar" :redirectUrl="portalUrl()" buttonText="Bestill time" :layout="layout"/>
            </div>
        </div>
    </div>
</template>

<script>
import Order from './components/Order.vue'
import { ProfileDropdown, ProfileDropdownMultiselect, NoContent, TitleAndEdit } from '../../../Common/CommonComponents'
import ProfileSvc from '../../../../services/profile-svc';
let profileSvc = null;
export default {
    components: { Order, ProfileDropdown, ProfileDropdownMultiselect, NoContent, TitleAndEdit },
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    data: () => ({
        temp: [],
        loading: false,
        orders: [],
        productOrders: [],
        combinedOrders: [],
        salons: [],
        page: 1,
        perPage: 10,
        types: [
            'Kommende',
            'Fullførte',
            'Avbestilte',
            'Ikke møtt'
        ],
        currentTypes: ['Alle typer'],
        currentSalon: 'Alle salonger'
    }),
    computed: {
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        orderApi() {
            return this.layout == "portal"
            ? process.env.VUE_APP_FIXIT_ORDER_API_URL
            : this.$config.VUE_APP_FIXIT_ORDER_API_URL
            ? this.$config.VUE_APP_FIXIT_ORDER_API_URL
            : process.env.VUE_APP_FIXIT_ORDER_API_URL;
        },
        pages() {
            return this.combinedOrders.length > 10
                ? Math.ceil(this.combinedOrders.length / 10)
                : 1;
        },
        visiblePages () {
            return this.combinedOrders.slice((this.page - 1)* this.perPage, this.page* this.perPage)
        }
    },
    methods: {
        switchComponent(order) {
            if (this.layout == 'chain') {
                if(!order.isProduct) {
                    var treatmentOrder = this.orders.find(x => x.appointmentId === order.id)
                    this.$router.push({query: { 
                        title: 'ordredetaljer', 
                        siteId: treatmentOrder.siteId, 
                        orderId: treatmentOrder.base64AppointmentId, 
                        type: ((order.fairPayStatus === 'PAID' && order.status === 'noshow') || (order.fairPayStatus === 'PARDONED' && order.status !== 'cancelled')) ? 4 : 1
                    }, params: {order: treatmentOrder}})
                } else {
                    this.$router.push({query: { title: 'ProduktOrdredetaljer', orderId: order.id }, params: {order: order}})
                }
            } else {
                if(!order.isProduct) {
                var treatmentOrder = this.orders.find(x => x.appointmentId === order.id)
                this.$router.push({name: 'Ordredetaljer', params: {
                    orderId: treatmentOrder.base64AppointmentId, 
                    siteId: treatmentOrder.siteId, 
                    order: treatmentOrder, 
                    type: ((order.fairPayStatus === 'PAID' && order.status === 'noshow') || (order.fairPayStatus === 'PARDONED' && order.status !== 'cancelled')) ? 4 : 1
                }})
                } else {
                    this.$router.push({name: 'ProduktOrdredetaljer', params: {orderId: order.id, order: order}})
                }
            }
        },
        portalUrl() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_URL :`/behandlinger`
        },
        updateOrderList(salon) {
            this.currentSalon = salon;
            this.page = 1
            this.combineOrdersMethod(this.orders, this.productOrders)
            this.combinedOrders = this.sortCombinedListByDate(this.combinedOrders)
            this.combinedOrders = (salon == 'Alle salonger') ? this.combinedOrders : this.combinedOrders.filter(x => x.siteName == salon)

            if (this.currentTypes !== 'Alle typer') {
                this.combinedOrders = this.filterByType(this.combinedOrders)
            }
            
        },
        updateOrderListbyType(items) {

            this.currentTypes = items;
            this.page = 1
            this.combineOrdersMethod(this.orders, this.productOrders)
            this.combinedOrders = this.sortCombinedListByDate(this.combinedOrders)

            let newList = this.combinedOrders;
            if (this.currentSalon !== 'Alle salonger') {
                newList = this.combinedOrders.filter(x => x.siteName == this.currentSalon)
            }
            this.combinedOrders = this.filterByType(newList)

        },

        filterByType(orderlist) {
            // If 'Alle typer' is selected, return the full order list
            if (this.currentTypes.includes('Alle typer')) {
                return orderlist;
            }

            // Filter the order list based on the selected types
            return orderlist.filter(order => {
                return this.currentTypes.some(type => {
                    switch (true) {
                        case type === 'Kommende':
                            return order.status === 'future-visit';
                        case type === 'Fullførte':
                            return order.status === 'previous-visit';
                        case type === 'Avbestilte':
                            return order.status === 'cancelled';
                        case type === 'Ikke møtt':
                            return order.status === 'noshow';
                        default:
                            return false;
                    }
                });
            });
        },
        combineOrdersMethod(treatmentOrders, productOrders) {
            var comboList = [];
            for(let x of treatmentOrders) {
                var order = {isProductReservation:(x.treatmentsOrdered === 0 && x.productsOrdered > 0), isProduct:false, id:x.appointmentId, siteName:x.siteName, fairPayType: x.fairPayType, status:x.appointmentStatus, startTime: x.appointmentStartTime, date:x.appointmentDate, total: x.revenue, productNumber:x.productsOrdered, fairPayStatus: x.fairPayStatus, actualFee: x.actualFee}
                if (!['FEE SENT', 'REMINDER1', 'REMINDER2'].includes(x.fairPayStatus)) {
                    comboList.push(order)
                }
            }
            for(let x of productOrders) {
                var order = {isProduct:true, id:x.orderId, siteName:x.salonName, status:x.orderStatusId, date:x.createdTime, total: x.totalPrice, productNumber: x.productsOrdered}
                comboList.push(order)
            }
            this.combinedOrders = comboList
        },
        sortCombinedListByDate(orderList) {
            return orderList.sort(function(a,b){
                return new Date(b.date) - new Date(a.date);
            });
        },
        sortByDate(orderList) {
            return orderList.sort(function(a,b){
                return new Date(b.appointmentDate) - new Date(a.appointmentDate);
            });
        },
        calculateDaysBetween(date1, date2) {
            return Math.round(Math.abs((date2 - date1) / (24 * 60 * 60 * 1000)));
        },
        description(order) {
            if(!order.isProduct && !order.isProductReservation){        
                if ((!order.fairPayStatus || order.fairPayStatus === 'UNKNOWN')) {
                    const currentOrderIndex     = this.combinedOrders.findIndex(x => x.id == order.id)
                    const appointmentDate       = new Date(order.date);
                    const daysFromToday         = (Math.round((new Date() - appointmentDate) / (24 * 60 * 60 * 1000)) - 1);
                    const mostRecentVisit       = this.combinedOrders.find(x => x.status == 'previous-visit')
                    const hoursAgo              = (new Date(order.date.split('T')[0] + 'T' + order.startTime.split('T')[1]) - Date.now()) / 36e5
                    const secondMostRecentVisit = mostRecentVisit ? this.combinedOrders.slice((this.combinedOrders.findIndex(x => x.id == mostRecentVisit.appointmentId) + 1)).find(x => x.status == 'previous-visit') : null
                    /**
                     * Calculate days between historic visits, excluding all other statuses.
                     */
                    let daysBetweenVisits = ''
                    let i = 1
                    while (i < this.combinedOrders.length) {
                        if (this.combinedOrders[currentOrderIndex - i] != undefined && this.combinedOrders[currentOrderIndex - i].status == 'previous-visit') {
                            daysBetweenVisits = this.calculateDaysBetween(appointmentDate, new Date(this.combinedOrders[currentOrderIndex - i].date))
                            break;
                        } else {
                            i++
                        }
                    }
                    const isNormalCancellation    = order.status == 'cancelled';
                    const isFutureButNotYetPaid   = Math.ceil(hoursAgo) <= 0 && order.status === 'future-visit'
                    const isToday                 = (daysFromToday == 0 || Math.ceil(hoursAgo) < 24) && order.status != 'previous-visit'
                    const isMostRecentVisit       = mostRecentVisit == order
                    const isSecontMostRecentVisit = (secondMostRecentVisit == order)
                    const isFuture                = daysFromToday <= 0
                    const daysBetween             = daysFromToday > 0
                    const isNoShowAppointment     = order.status === 'noshow'

                    switch (true) {
                        case isNoShowAppointment:
                            return 'Ikke møtt til besøk' //noshow. UNKNOWN
                        case isFutureButNotYetPaid:
                            return 'For ' + Math.abs(Math.round(hoursAgo)) + ' timer siden' 
                        case isNormalCancellation:
                            return 'Avbestilt'
                        case isToday:
                            return 'Idag'
                        case isMostRecentVisit:
                            return 'Siste besøk'
                        case isSecontMostRecentVisit:
                            return daysBetweenVisits + ' dager siden siste besøk'
                        case isFuture: 
                            return 'Om ' + Math.abs(daysFromToday) + ' dager';
                        case daysBetween:
                            return daysBetweenVisits + ' dager mellom besøk';
                        default:
                            return ''
                    }
                } 
                else {
                    const hoursAgo = (new Date(order.date.split('T')[0] + 'T' + order.startTime.split('T')[1]) - Date.now()) / 36e5
                    const isNoShowFee           = order.fairPayType !== 'CANCELLATION' && ['noshow'].includes(order.status) && order.fairPayStatus === 'PAID';
                    const isLateCancellationFee = order.fairPayType === 'CANCELLATION' && ['noshow'].includes(order.status) && order.fairPayStatus === 'PAID';
                    const isPaidAndCancelled    = order.fairPayStatus === 'PAID' && ['cancelled'].includes(order.status);
                    const isFutureButNotYetPaid = order.fairPayStatus === 'NEW'  && ['future-visit', 'noshow'].includes(order.status)
                    const isLateCancellation = order.fairPayStatus === 'NEW'  && ['cancelled'].includes(order.status)
                    const isPardoned            = order.fairPayStatus === 'PARDONED' && order.status === 'noshow'
                    const isCancelled           = order.fairPayStatus === 'PARDONED' && order.status === 'cancelled'

                    switch (true) {
                        case isFutureButNotYetPaid:
                            return 'For ' + Math.abs(Math.round(hoursAgo)) + ' timer siden' 
                        case isLateCancellationFee:
                            return 'Avbestillingsgebyr'  //PAID, noshow, type == 2 (FEE)
                        case isNoShowFee:
                            return 'Ikke møtt gebyr'     //PAID, noshow, type != 2 (FEE)
                        case isPardoned:
                            return 'Gebyr trukket'       //PADRONED
                        case isCancelled || isLateCancellation || isPaidAndCancelled: // (Original appointment)
                            return 'Avbestilt'
                        default:
                            return ''
                    }
                }
            } else {
                if (order.status === 'Cancelled') {
                    return 'Avbestilt'
                }
                else if (order.status === 'Credited') {
                    return 'Retur av ' + (order.productNumber > 1 ? order.productNumber + " produkter" : order.productNumber + " produkt")
                }
                else {
                    return (order.productNumber > 1) ? order.productNumber + " produkter" : order.productNumber + " produkt"
                }
            }
        },
    },
    async created() {
		profileSvc = await ProfileSvc(this.$axios);
        this.loading = true;
        var siteIds = this.layout == 'chain' ? (this.$store.getters['salon/getSiteIds'] ? this.$store.getters['salon/getSiteIds'] : this.$store.getters['site/getChainSiteIds']) : []
        this.orders = await profileSvc.GetUserAppointments(this.bookingApi, siteIds)
        this.orders = this.orders.filter(x => !(x.fairPayType === 'CANCELLATION' && x.fairPayStatus === 'NEW' && x.orderHistoryType === 4))
        this.productOrders = await profileSvc.GetUserOrderHistory(this.orderApi, siteIds)

        this.combineOrdersMethod(this.orders, this.productOrders)
        this.combinedOrders = this.sortCombinedListByDate(this.combinedOrders)
        this.salons = this.combinedOrders.length ? this.combinedOrders.map(x => x.siteName) : []
        this.loading = false;
        this.updateOrderListbyType(['Kommende', 'Fullførte', 'Ikke møtt'])
	},
    beforeDestroy() {
		profileSvc = null
	}
}
</script>

<style scoped>
.dropdown-container {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.dropdown-item {
  flex: 1 1 50%;    
  max-width: 50%;   
  min-width: 0;     
}
</style>